
import React from 'react';
import { Outlet } from 'react-router-dom';
import { useTenantAccess } from '@/contexts/TenantAccessContext';
import { ModuleKey } from '@/access/modules';
import AccessDenied from '@/pages/AccessDenied';

interface ModuleGuardProps {
    module: ModuleKey | ModuleKey[];
    children?: React.ReactNode;
}

export const ModuleGuard: React.FC<ModuleGuardProps> = ({ module, children }) => {
    const { can, isLoading } = useTenantAccess();

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-[50vh]">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
        );
    }

    let allowed = false;
    if (Array.isArray(module)) {
        allowed = module.some(m => can(m));
    } else {
        allowed = can(module);
    }

    if (!allowed) {
        return <AccessDenied />;
    }

    return children ? <>{children}</> : <Outlet />;
};
